<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <loading
        :active.sync="estatusMovimientoService.loading === true"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <b-container fluid>
      <b-card>
        <template #header>
          <b-row class="transparent">
            <b-col cols="10">
              <h3 class="text-left">
                Bandeja solicitud de Movimientos
              </h3>
            </b-col>
            <b-col cols="2">
              Codigo: <b> MV_SALDOS_TRASNFERENCIAS </b>
            </b-col>
          </b-row>
        </template>
        <b-card-body>
          <b-tabs>
            <b-tab lazy title="Movimientos">
              <b-container fluid class="mt-3">
                <b-tabs>
                  <template v-for="estatus in estatusMovimiento">
                    <b-tab lazy
                        v-if="movimientoService.puedeVerListaMovimiento(estatus.value)"
                        :title="estatus.text"
                        :key="estatusMovimiento.indexOf(estatus)"
                    >
                      <b-container fluid>
                        <div>

                        </div>
                        <ListaMovimientosPorEstatus :estatus="estatus.value"></ListaMovimientosPorEstatus>
                      </b-container>
                    </b-tab>
                    <b-tab v-else title="Sin permisos"
                           :key="estatusMovimiento.indexOf(estatus)"
                    >
                      <div class="alert alert-info">No tienes permisos para ver esta tabla</div>
                    </b-tab>
                  </template>

                </b-tabs>
              </b-container>
            </b-tab>
            <b-tab lazy title="Transferencias de saldo">
              <b-container fluid class="mt-3">
                <b-tabs>
                  <template v-for="estatus in estatusMovimiento">
                    <b-tab lazy
                        v-if="movimientoService.puedeVerListaTransferencia(estatus.value)"
                        :title="estatus.text"
                        :key="estatusMovimiento.indexOf(estatus)"
                    >
                      <b-container fluid>
                        <ListaTraspasosPorEstatus :estatus="estatus.value"></ListaTraspasosPorEstatus>
                      </b-container>
                    </b-tab>
                    <b-tab v-else title="Sin permisos"
                           :key="estatusMovimiento.indexOf(estatus)"
                    >
                      <div class="alert alert-info">No tienes permisos para ver esta tabla</div>
                    </b-tab>
                  </template>

                </b-tabs>
              </b-container>
            </b-tab>
            <b-tab lazy title="Cashback">
              <b-container fluid class="mt-3">
                <b-tabs>
                  <template v-for="estatus in estatusMovimiento">
                    <b-tab lazy
                        v-if="movimientoService.puedeVerListaCashBack(estatus.value)"
                        :title="estatus.text"
                        :key="estatusMovimiento.indexOf(estatus)"
                    >
                      <b-container fluid>
                        <ListaCashbackPorEstatus :estatus="estatus.value"></ListaCashbackPorEstatus>
                      </b-container>
                    </b-tab>
                    <b-tab v-else title="Sin permisos"
                           :key="estatusMovimiento.indexOf(estatus)"
                    >
                      <div class="alert alert-info">No tienes permisos para ver esta tabla</div>
                    </b-tab>
                  </template>
                </b-tabs>
              </b-container>
            </b-tab>

            <b-tab lazy title="Reembolsos">
              <b-container fluid class="mt-3">
                <b-tabs>
                  <template v-for="estatus in estatusMovimiento">
                    <b-tab lazy
                        v-if="movimientoService.puedeVerListaReembolsos(estatus.value)"
                        :title="estatus.text"
                        :key="estatusMovimiento.indexOf(estatus)"
                    >
                      <b-container fluid>
                        <ListaReembolsosPorEstatus :estatus="estatus.value"></ListaReembolsosPorEstatus>
                      </b-container>
                    </b-tab>
                    <b-tab v-else title="Sin permisos"
                           :key="estatusMovimiento.indexOf(estatus)"
                    >
                      <div class="alert alert-info">No tienes permisos para ver esta tabla</div>
                    </b-tab>
                  </template>
                </b-tabs>
              </b-container>
            </b-tab>
          </b-tabs>


        </b-card-body>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header";
import {EstatusMovimientoService} from "../../apiServices/estatusMovimiento/EstatusMovimientoService";
import ListaMovimientosPorEstatus from "./movimiento/ListaMovimientosPorEstatus";
import ListaTraspasosPorEstatus from "./traspaso/ListaTraspasosPorEstatus";
import {MovimientoService} from "../../apiServices/movimiento/MovimientoService";
import ListaCashbackPorEstatus from "./cashback/ListaCashbackPorEstatus";
import ListaReembolsosPorEstatus from "@/views/movimientos/reembolso/ListaReembolsosPorEstatus";

export default {
  name: "movimientos",
  components: {
    ListaReembolsosPorEstatus,
    ListaCashbackPorEstatus, ListaTraspasosPorEstatus, ListaMovimientosPorEstatus, Header},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    estatusMovimientoService: new EstatusMovimientoService(),
    movimientoService: new MovimientoService(),
    estatusMovimiento: [],
  }),
  async mounted() {
    this.estatusMovimiento = await this.estatusMovimientoService.listar();
  },
  methods: {
    emitReloadMovimientos(estatus) {
      this.$root.$emit('reload-movimientos', estatus)
    },
    emitReloadTransferencias(estatus) {
      this.$root.$emit('reload-traspasos', estatus)
    },
    emitReloadCashBack(estatus) {
      this.$root.$emit('reload-cashback', estatus)
    },
    emitReloadReembolsos(estatus) {
      this.$root.$emit('reload-reembolsos', estatus)
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>

</style>
